import React from 'react'

const EditIconBlue = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
    >
      <path
        d="M11.3073 4.51986L8.45457 1.70068L9.39429 0.760959C9.6516 0.503653 9.96775 0.375 10.3427 0.375C10.7173 0.375 11.0332 0.503653 11.2905 0.760959L12.2303 1.70068C12.4876 1.95799 12.6218 2.26855 12.633 2.63236C12.6442 2.99572 12.5211 3.30605 12.2638 3.56336L11.3073 4.51986ZM10.334 5.50993L3.21895 12.625H0.366211V9.77226L7.48128 2.65719L10.334 5.50993Z"
        fill="#3249D7"
      />
    </svg>
  )
}

export default EditIconBlue
